import { TUpdateBadgeSlot } from '@src/modules'

import { request } from './config'

export const getBadgeCatalogAdmin = (token: string) =>
  request({ url: 'badge/catalog/admin', method: 'GET' }, { token })

export const patchBadgeSlot = (id: number, body: TUpdateBadgeSlot, token: string) =>
  request({ url: `badge/catalog/admin/${id}`, method: 'PATCH', data: body }, { token })
